export interface bl_fi_generic_doc_arap_contra_RowInterface {
  guid: string;
  guid_doc_1_hdr: string;
  guid_doc_2_hdr: string;
  server_doc_type_doc_1: string;
  server_doc_type_doc_2: string;
  amount_contra: number;
  date_txn: string;
  date_doc_1: string;
  date_doc_2: string;
  created_date: string;
  updated_date: string;
  status: string;
  revision: string;
  vrsn: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
}

export class bl_fi_generic_doc_arap_contra_RowClass implements bl_fi_generic_doc_arap_contra_RowInterface {
  guid: string;
  guid_doc_1_hdr: string;
  guid_doc_2_hdr: string;
  server_doc_type_doc_1: string;
  server_doc_type_doc_2: string;
  amount_contra: number;
  date_txn: string;
  date_doc_1: string;
  date_doc_2: string;
  created_date: string;
  updated_date: string;
  status: string;
  revision: string;
  vrsn: string;
  created_by_subject_guid: string;
  updated_by_subject_guid: string;
}
